namespace GeniuzPOS.Inventory {
    export class IcStockSoldColumns {
        static columnsKey = 'Inventory.IcStockSold';
    }
}
